import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const Footer = () => {
  const footerLinks = [
    {
      title: 'FOR EMPLOYERS',
      items: [
        {
          title: 'HRMS',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/hrms',
          target: '_blank',
        },
        {
          title: 'Outsource',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/edu',
          target: '_blank',
        },
        {
          title: 'Strategic Hiring',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/strategic-hiring',
          target: '_blank',
        },
        {
          title: 'Tencent Palm',
          link: 'palm.' + process.env.REACT_APP_ADNEXIO_NEXT_URL,
          target: '_blank',
        },
      ],
    },
    {
      title: 'FOR JOBSEEKERS',
      items: [
        {
          title: 'Jobs',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/jobs',
          target: '_blank',
        },
        {
          title: 'Bootcamps',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/bootcamps',
          target: '_blank',
        },
      ],
    },
    {
      title: 'INFO',
      items: [
        {
          title: 'FAQs',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/FAQs',
          target: '_blank',
        },
        {
          title: 'T&C',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/terms-conditions',
          target: '_blank',
        },
        {
          title: 'Contact Us',
          link: process.env.REACT_APP_ADNEXIO_NEXT_URL + '/contact-us',
          target: '_blank',
        },
      ],
    },
    {
      title: 'STAY CONNECTED',
      items: [
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/adnexio.jobs/',
          target: '_blank',
        },
        {
          title: 'X',
          link: 'https://twitter.com/adnexio_/',
          target: '_blank',
        },
        {
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/company/adnexiojobs/',
          target: '_blank',
        },
        {
          title: 'Instagram',
          link: 'https://www.instagram.com/adnexio_/',
          target: '_blank',
        },
      ],
    },
  ]

  const goToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <Box
      component={'footer'}
      sx={{
        background: 'linear-gradient(87deg, #FFF7D9 23.7%, #F9F7EF 52.31%, #FFF7D9 80.93%)',
        height: { md: '400px' },
        px: { xs: 3, sm: '145px' },
        py: 8,
        width: 1,
      }}
    >
      <Box
        height={1}
        display={'flex'}
        flexDirection={'column'}
        gap={4}
        justifyContent={'space-between'}
      >
        <Stack direction={{ xs: 'column', md: 'row' }} gap={6} justifyContent={'space-between'}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Box
              component={'img'}
              src={'/adnexio-logo-text.svg'}
              alt="adnexio logo"
              onClick={goToTop}
              sx={{ cursor: 'pointer' }}
              width={160}
              height={32}
            />
            <Box
              component={'img'}
              src={'/logo-lhdn.png'}
              alt="lhdn logo"
              onClick={goToTop}
              sx={{ cursor: 'pointer' }}
              width={117}
              height={91}
            />
          </Box>
          <Stack direction={{ xs: 'column', lg: 'row' }} gap={{ xs: 4, lg: 2 }}>
            {footerLinks.map((value, index) => (
              <Stack spacing={'10px'} key={index} width={130}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }} color={'primary.main'}>
                  {value.title}
                </Typography>
                {value.items.map((value, idx) => (
                  <Link
                    key={idx}
                    href={value.link}
                    variant="body1"
                    underline="hover"
                    color={'inherit'}
                  >
                    {value.title}
                  </Link>
                ))}
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction={'row'}>
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              adnexio is a product by INVOKE / Copyright © 2025 | All rights reserved
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  )
}

export default Footer
